import { Skeleton } from "@kirvanobr/skeleton";
import { Typography } from "@kirvanobr/typography";
import { styles } from "./ContentDropzone.styles";
import { ContentDropzoneProps } from "./ContentDropzone.types";
import { useContentDropzone } from "./useContentDropzone";

export const ContentDropzone = ({ onFileUpload, multiple = false, isLoading }: ContentDropzoneProps) => {
  const { state, getRootProps, getInputProps, isDragActive, renameFile, cancelRenameFile } = useContentDropzone({
    onFileUpload,
    multiple,
    isLoading,
  });

  if (isLoading) return <Skeleton height={192} className="w-full h-[192px] rounded" />;

  // if (state?.showRenameFile)
  //   return (
  //     <RenameFileOnUpload
  //       handleRenameFile={renameFile}
  //       handleCancel={cancelRenameFile}
  //       fileName={state.files ? state.files[0].name.replace(fileExtensionRegex, "") : undefined}
  //     />
  //   );

  return (
    <div className={styles({ isActive: isDragActive }).base()} {...getRootProps()}>
      <div className={styles().content()}>
        <div className={styles().uploadArea()}>
          <input {...getInputProps()} />

          <>
            <div className="text-center">
              <div className="mb-5 text-center">
                <Typography size="t5" variant="title" className="text-primary">
                  Selecione do seu dispositivo
                </Typography>
                <Typography size="t3">ou solte arquivos aqui</Typography>
              </div>
              <Typography size="t5" className="text-foreground-400">
                Você pode inserir arquivos em: pdf, jpg, gif, png, zip, mp3, doc, ppt e outros.
              </Typography>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};
